import { useEffect, useState } from "react";
import { PinIcon, Check } from "lucide-react";
import { api } from "@/lib/api";
import { ANNOUNCEMENTS_HISTORY_TAB } from "@/constants/testIds";

export function AnnouncementsHistoryTab({ employeeId }) {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    api.get(`/announcements/employee/${employeeId}`).then(({ data }) => setAnnouncements(data));
  }, [employeeId]);

  return (
    <div className="space-y-3 mt-4">
      <p className="text-sm text-charcoal/60">Avisos recibidos por este empleado y si ya los leyó.</p>
      {announcements.map((a) => (
        <div key={a.id} data-testid={ANNOUNCEMENTS_HISTORY_TAB.row} className="bg-card border border-petroleum/10 rounded-xl p-4 flex items-start justify-between gap-3">
          <div className="flex items-start gap-2 min-w-0">
            <PinIcon className="w-4 h-4 text-terracotta mt-0.5 shrink-0" strokeWidth={1.5} />
            <div>
              <p className="text-charcoal text-sm">{a.message}</p>
              <p className="text-xs text-charcoal/50 mt-1">{a.recipient_type === "all" ? "Enviado a todos" : "Enviado directamente"} · por {a.created_by}</p>
            </div>
          </div>
          {a.read ? (
            <span className="flex items-center gap-1 text-xs font-medium text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-full shrink-0"><Check className="w-3 h-3" /> Leído</span>
          ) : (
            <span className="text-xs font-medium text-amber-700 bg-amber-50 px-2.5 py-1 rounded-full shrink-0">Sin leer</span>
          )}
        </div>
      ))}
      {announcements.length === 0 && <p className="text-charcoal/50 text-sm">Este empleado no ha recibido avisos.</p>}
    </div>
  );
}
